import { render, staticRenderFns } from "./TernaryAnagraphicInput.vue?vue&type=template&id=8f845b38&"
import script from "./TernaryAnagraphicInput.vue?vue&type=script&lang=ts&"
export * from "./TernaryAnagraphicInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports